<script>
	import KoFi from './components/ko-fi.svelte'

	let innerWidth;
	let innerHeight;

	const openLink = (url) => {
		window.open(url)
	}

	const toggleDrawer = () => {

	}
</script>

<svelte:window bind:innerWidth={innerWidth} bind:innerHeight={innerHeight} />

<nav class="uk-navbar-container" uk-navbar uk-sticky>
	{#if innerWidth > 900}
		<div class="uk-navbar-left">
			<ul class="uk-navbar-nav">
				<li><a href="https://github.com/fudgepop01/amiibox">github repo</a></li>
			</ul>
		</div>
		<div class="uk-navbar-center">
			<div class="uk-navbar-center-left">
				<ul class="uk-navbar-nav">
					<li class="uk-active"><a href="##">tournament edition</a></li>
				</ul>
			</div>
			<div class="uk-navbar-item uk-logo">
				<img class="logo" src="./images/icon.png" alt="amiibox logo" uk-img/>
			</div>
			<div class="uk-navbar-center-right">
				<ul class="uk-navbar-nav">
					<li><a href="#none">[coming soon<sup>tm</sup>]</a></li>
				</ul>
			</div>
		</div>
		<div class="uk-navbar-right">
			<ul class="uk-navbar-nav">
				<li><a href="https://github.com/fudgepop01/amiibox"><KoFi user="fudgepop01" background="transparent" color="black"/></a></li>
			</ul>
		</div>
	{:else}
		<div class="uk-navbar-left">
			<!-- svelte-ignore a11y-missing-content -->
			<a on:click={toggleDrawer} class="uk-navbar-toggle" uk-toggle uk-navbar-toggle-icon href="#offcanvas"></a>
		</div>
		<div class="uk-navbar-center">
			<div class="uk-navbar-item uk-logo">
				<img class="logo" src="./images/icon.png" alt="amiibox logo" uk-img/>
			</div>
		</div>
	{/if}
</nav>

{#if innerWidth < 900}
	<div id="offcanvas" uk-offcanvas="overlay: true; mode: push">
		<div class="uk-offcanvas-bar uk-flex uk-flex-column">
				<button class="uk-offcanvas-close" type="button" uk-close></button>

					<ul class="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
						<li class="uk-active item"><a href="##">tournament edition</a></li>
						<li class="item"><a href="##">(full version coming soon<sup>TM</sup>)</a></li>
						<li class="uk-nav-divider"></li>
						<li class="uk-nav-header">External Links</li>
						<li><a href="https://www.twitter.com/fudgepop01"><span uk-icon="icon: twitter"></span> twitter</a></li>
						<li><a href="https://github.com/fudgepop01"><span uk-icon="icon: github"></span> github</a></li>
						<li class="uk-nav-divider"></li>
						<li class="uk-nav-header">Donate</li>
						<li class="item"><KoFi user="fudgepop01"/></li>
					</ul>
		</div>
	</div>
{/if}

<div class="uk-height-medium uk-width-1-1 uk-flex uk-flex-column uk-flex-middle uk-flex-center">
	<h1 class="{innerWidth > 500 ? 'uk-heading-large' : ''}">-\Tournamiibox/-</h1>
	<div class="uk-button-group {innerWidth > 500 ? 'uk-padding' : ''} uk-width-xlarge">
		<button class="uk-button uk-button-primary uk-width-1-2" on:click={() => openLink('https://github.com/fudgepop01/amiibox/releases/latest/download/tournament_legal.zip')}>get tournamiibox</button>
		<button class="uk-button uk-button-secondary uk-width-1-2" on:click={() => openLink('./downloads/Validator.zip')}>get amiibo validator</button>
	</div>
</div>

<main>
	<div class="uk-section uk-section-default uk-align-center uk-padding-remove">
		<div class="uk-container">
			<h1 class="uk-heading-divider">
				Open, Tournament-Legal Amiibo Tools for Everyone
			</h1>
			<div>
				<p>
					Amiibox is an amiibo modding tool developed by
					<a href="https://twitter.com/fudgepop01">fudgepop01</a>
					for the purpose of experimentation, exploration, and convenience.
					It allows you to take an amiibo bin file, modify its properties, and save
					it. Think powersaves - but fully customizable and absolutely free!
				</p>
				<p>
					The version on this page is a version of amiibox tailored to keeping
					things "tournament legal." Unlike the full version, the nickname
					and marker bit stay completely unmodified. This means you're able to
					experiment and acquire spirit abilities guilt-free.
				</p>
				<p>
					You can also modify the attack and defense values up to a total
					of 5000 points. This is the natural limit in-game, so it's the natural
					limit here too. You are expected to stay within the limits of whatever
					tournament you enter, however. You can also adjust the "gift" value,
					allowing you to farm amiibo gifts if that's what you really want to do.
				</p>
				<p>
					One thing folks will be most excited about is the ability to
					adjust the amiibo's level. Training an amiibo to level 50 can take time-
					time that many don't have as they grow older. It's also annoying when an
					amiibo has AI that you like that you wish to keep, but are forced to risk
					getting rid of it for the sake of leveling it up so it's not at a severe
					disadvantage in tournaments. Now you can circumvent that whole ordeal!
				</p>
			</div>
		</div>
	</div>

	<div class="uk-section uk-section-default uk-align-center uk-padding-remove">
		<div class="uk-container">
			<h1 class="uk-heading-divider">
				An Amiibo Bin Validator
			</h1>
			<div>
				<p>
					the LAST thing I wanted to do with the release of powerful amiibo modding
					tools like this is disrupt any existing communities built around training
					amiibo by hand. To ensure this doesn't happen, I have also created a tool
					that lets TOs validate a collection of amiibo bins in an instant. This
					will eventually be made into a part of this site, but for now it's a
					standalone program.
				</p>
				<p>
					This program can be configured in a number of ways. through a text file
					called "rules.txt" --
					The options include:
				</p>
				<ul class="uk-list uk-list-bullet uk-list-collapse">
					<li>auto sort</li>
					<li>output file</li>
					<li>ban amiibox (full)</li>
					<li>
						limit stat modification
						<ul class="uk-list uk-list-circle uk-list-collapse">
							<li>can also get more specitic</li>
							<li></li>
						</ul>
					</li>
					<li>ban typing (attack, defense, grab)</li>
					<li>
						<b>ban spirit abilites</b>
						<ul class="uk-list uk-list-circle uk-list-collapse">
							<li>can specify which abilities to "include" or "exclude"</li>
						</ul>
					</li>
				</ul>
				<p>
					I look forward to seeing all the possibilities now that there's a quick way
					to validate bins according to a ruleset!~
				</p>
			</div>
		</div>
	</div>
</main>

<footer class="uk-height-small uk-text-large uk-text-center uk-padding-small">
	made with <span uk-icon="icon: heart"></span> by <a href="https://twitter.com/fudgepop01">fudgepop01</a>
	<div class="uk-padding-small">
		<KoFi user="fudgepop01"/>
	</div>
</footer>

<style>
	.logo {
		width: 80px;
	}

	main {
		padding: 0 40px;
	}

	footer {
		background-color: black;
		color: white;
	}
</style>